<ng-container>
  <div class="profile-main">
    <div class="profile-main__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

